/**
 * 集中管理所有 API 路径常量
 * 使用 :param 语法定义动态段
 */
export const API_PATHS = {
  AUTH: {
    LOGIN: '/public/v1/affiliate_partner/agents/login',
  },
  ACCOUNT: {
    PROFILE: '/v1/affiliate_partner/agents/:agentId',
    UPDATE_NICKNAME: '/v1/affiliate_partner/agents/:agentId/nickname',
    UPDATE_PASSWORD: '/v1/affiliate_partner/agents/:agentId/password',
  },
  AFFILIATE: {
    PROMO_LINK: '/v1/affiliate_partner/agents/:agentId/promo-link',
    RECENT_CONSUMERS:
      '/v1/affiliate_partner/agents/:agentId/consumers/recently',
  },
  PERFORMANCE: {
    MONTHLY_REVENUE: '/v1/affiliate_partner/agents/:agentId/monthly/revenue',
    LAST_MONTH_REVENUE:
      '/v1/affiliate_partner/agents/:agentId/last_month/revenue',
    LAST_7_DAYS_REVENUE:
      '/v1/affiliate_partner/agents/:agentId/last7days/revenue',
    CONSUMERS_COUNT: '/v1/affiliate_partner/agents/:agentId/consumers/count',
  },
} as const
